mutation CreateMoneyPage($input: UrlCreateInput!) {
    maUrlCreate(input: $input) {
        url {
            name
            url {
                fullyQualifiedUrl
                pageTitle
            }
            htmlUrlPath
        }
    }
}
